import { HTMLAttributes } from 'react'
import { DisplayProps, MarginProps, PositionProps } from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import { SIZE } from 'designSystem/foundations/constants/size'

import PDSFlexBox from '../PDSFlexBox/PDSFlexBox'
import { INTERNAL_ComparisonRenderUnit } from './INTERNAL_ComparisonTableTypes'
import INTERNALxComparisonHeader from './INTERNALxComparisonHeader'
import INTERNALxComparisonItem from './INTERNALxComparisonItem'

export type ComparisonRenderUnit = INTERNAL_ComparisonRenderUnit

export type ComparisonItem = {
  rows: ComparisonRenderUnit[]
  header: ComparisonRenderUnit
}

type BaseProps = HTMLAttributes<HTMLSpanElement> &
  DisplayProps &
  MarginProps &
  PositionProps &
  TestIdProps

type Props = {
  title?: string
  headers: INTERNAL_ComparisonRenderUnit[]
  items: ComparisonItem[]
} & BaseProps

export default function PDSComparisonTable({
  headers,
  items,
  testId,
  title,
  ...props
}: Props) {
  return (
    <PDSFlexBox testId={testId} {...props} gap={SIZE.s16} width="100%">
      <INTERNALxComparisonHeader
        headers={headers}
        testId={testId}
        title={title}
      />

      <PDSFlexBox gap={SIZE.s16} flex={2}>
        {items?.map((item, i) => (
          <INTERNALxComparisonItem
            key={`comparison-item-${i}`}
            header={item.header}
            rows={item.rows}
            testId={testId}
          />
        ))}
      </PDSFlexBox>
    </PDSFlexBox>
  )
}
